import jwtAuthAxios from "services/jwtAuth";
import {
    createSlice ,
    createAsyncThunk
}                   from '@reduxjs/toolkit';

export const getById=createAsyncThunk ( "paymentDeferment/getById" , async ( val ) => {
    try {
        let token=await localStorage.getItem ( 'auth_token' );
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ]=
            'Bearer ' + token;
        const url=`v1/payment-deferment/${val}`
        const response=await jwtAuthAxios.get ( url )
        return response.data
    } catch (response) {
        throw response
    }
} );

export const findAll=createAsyncThunk ( "paymentDeferment/findAll" , async () => {
    try {
        let token=await localStorage.getItem ( 'auth_token' );
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ]=
            'Bearer ' + token;
        const url=`v1/payment-deferment`
        const response=await jwtAuthAxios.get ( url )
        return response.data
    } catch (response) {
        throw response
    }
} );

export const remove=createAsyncThunk ( "paymentDeferment/remove" , async ( val ) => {
    try {
        let token=await localStorage.getItem ( 'auth_token' );
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ]=
            'Bearer ' + token;
        const url=`v1/payment-deferment/${val}`
        const response=await jwtAuthAxios.delete ( url )
        return response.data
    } catch (response) {
        throw response
    }
} );

export const upsert=createAsyncThunk ( "paymentDeferment/upsert" , async ( val ) => {
    try {
        let token=await localStorage.getItem ( 'auth_token' );
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ]='Bearer ' + token;
        const url=`v1/payment-deferment`
        const response=await jwtAuthAxios.post ( url , val )
        return response.data
    } catch (response) {
        throw response
    }
} );

export const findByParam=createAsyncThunk ( "paymentDeferment/findByParam" , async ( val ) => {
    try {
        let token=await localStorage.getItem ( 'auth_token' );
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ]=
            'Bearer ' + token;
        const url=`v1/payment-deferment/param`
        const response=await jwtAuthAxios.post ( url , val )
        return response.data
    } catch (response) {
        throw response
    }
} );

const initialState={
    loading : false ,
    data : {} ,
    dataList : [] ,
}

const paymentDefermentSlice=createSlice (
    {
        name : "paymentDeferment" ,
        initialState : initialState ,
        extraReducers : ( builder ) => {
            builder
                .addCase ( getById.pending , ( state ) => {
                    state.loading=true;
                } )
                .addCase ( getById.fulfilled , ( state , action ) => {
                    state.data=action.payload;
                    state.loading=false;
                } )
                .addCase ( getById.rejected , ( state , action ) => {
                    state.loading=false;
                } )
            builder
                .addCase ( findAll.pending , ( state ) => {
                    state.loading=true;
                } )
                .addCase ( findAll.fulfilled , ( state , action ) => {
                    state.data=action.payload;
                    state.loading=false;
                } )
                .addCase ( findAll.rejected , ( state , action ) => {
                    state.loading=false;
                } )
            builder
                .addCase ( upsert.pending , ( state ) => {
                    state.loading=true;
                } )
                .addCase ( upsert.fulfilled , ( state , action ) => {
                    state.data=action.payload;
                    state.loading=false;
                } )
                .addCase ( upsert.rejected , ( state , action ) => {
                    state.loading=false;
                } )
            builder
                .addCase ( remove.pending , ( state ) => {
                    state.loading=true;
                } )
                .addCase ( remove.fulfilled , ( state , action ) => {
                    state.data=action.payload;
                    state.loading=false;
                } )
                .addCase ( remove.rejected , ( state , action ) => {
                    state.loading=false;
                } )
            builder
                .addCase ( findByParam.pending , ( state ) => {
                    state.loading=true;
                } )
                .addCase ( findByParam.fulfilled , ( state , action ) => {
                    state.dataList=action.payload?.data;
                    state.loading=false;
                } )
                .addCase ( findByParam.rejected , ( state , action ) => {
                    state.loading=false;
                } )
            ;
    }
                                          } )
export const paymentDefermentSelectors=( state ) => state.paymentDeferment;
export default paymentDefermentSlice.reducer;